<template>
  <div class="charg-template">
    <div class="charg-template-top">
      <span>计费模板</span>
    </div>
    <div class="charg-template-bottom">
      <div class="template-bottom-top">
        <el-select v-model="provincesName" clearable placeholder="请选择" @change="provincesChange">
          <el-option
            v-for="item in provincesList"
            :key="item.province"
            :label="item.province"
            :value="item.province">
          </el-option>
        </el-select>
        <el-select v-model="cityName" clearable placeholder="请选择城市" @change="cityChange">
          <el-option
            v-for="item in cityList"
            :key="item.city"
            :label="item.city"
            :value="item.city"
          ></el-option>
        </el-select>
        <el-select v-model="stationName" clearable placeholder="请选择场站" @change="stationChange">
          <el-option
            v-for="item in stationList"
            :key="item.station_id"
            :label="item.station_name"
            :value="item.station_id"
          ></el-option>
        </el-select>
        <el-button class="search" @click="searchClick()">查询</el-button>
        <el-button class="new-template" @click="newTemplateClick()" :disabled="addPrivilege==1" :class="[addPrivilege==1?'active':'']">新建模板 +</el-button>
        <!-- <a class="alinkbutton" href='../../assets/css/筛选订单数据.csv' download="已筛选订单数据.csv" >导出</a> -->
      </div>
      <div class="template-bottom-table">
        <el-table
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          :data="yemiandata"
          border
          style="width: 100%">
          <el-table-column
            prop="name"
            label="模板名"
            width="">
          </el-table-column>
          <el-table-column
            prop="station_name"
            label="场站"
            width="">
          </el-table-column>
          <el-table-column
            prop="supplier"
            label="模板类型"
            width="">
            <template slot-scope="scope">{{ scope.row.supplier | defaultValFilter }}</template>
          </el-table-column>
          <!-- <el-table-column
            prop="rate1"
            label="费率1电价">
            <template slot-scope="scope">{{ scope.row.rate1 | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="rate2"
            label="费率2电价"
            width="">
            <template slot-scope="scope">{{ scope.row.rate2 | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="rate3"
            label="费率3电价"
            width="">
            <template slot-scope="scope">{{ scope.row.rate3 | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="rate4"
            label="费率4电价">
            <template slot-scope="scope">{{ scope.row.rate4 | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="serv_fee"
            label="服务费"
            width="">
            <template slot-scope="scope">{{ scope.row.serv_fee | defaultValFilter }}</template>
          </el-table-column> -->
          <el-table-column
            prop="timestamp"
            label="创建时间"
            width="">
            <template slot-scope="scope">{{ scope.row.timestamp | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            width="145">
            <template slot-scope="scope">
              <el-button class="list-delete" @click="deleteTemplate(scope.row)" :disabled="deletePrivilege==1" :class="[deletePrivilege==1?'active':'']">删除</el-button>
              <el-button class="list-details" @click="detailsTemplate(scope.row.id)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange" 
          @current-change="currentChange"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <!-- 新建模板 -->
    <el-dialog
		  title=""
		  :visible.sync="newTemplateDialog"
      customClass="new-template-dialog"
		  width="934px"
      @close="templateConcel"
		  >
      <p class="title">{{templateTitle}}</p>
      <div class="line"></div>
      <div class="new-template-content">
        <div class="dialog-top">
          <div class="one">
            <div class="supplier">
              <span>模板类型：</span>
              <el-select v-model="supplierName" :disabled="disabledWJ==true" clearable placeholder="请选择" @change="supplierChange">
                <el-option
                  v-for="item in supplierList"
                  :key="item.label"
                  :label="item.label"
                  :value="item.label">
                </el-option>
              </el-select>
            </div>
            <div class="station">
              <span>场站：</span>
              <el-select v-model="dialogProvincesName" :disabled="disabledWJ==true" clearable placeholder="请选择城市" @change="dialogProvincesChange">
                <el-option
                  v-for="item in dialogProvincesList"
                  :key="item.province"
                  :label="item.province"
                  :value="item.province">
                </el-option>
              </el-select>
              <el-select v-model="dialogCityName"  :disabled="disabledWJ==true" clearable placeholder="请选择城市" @change="dialogCityChange">
                <el-option
                  v-for="item in dialogCityList"
                  :key="item.city"
                  :label="item.city"
                  :value="item.city">
                </el-option>
              </el-select>
              <el-select v-model="dialogStationName" :disabled="disabledWJ==true" clearable placeholder="请选择场站" @change="dialogStationChange">
                <el-option
                  v-for="item in dialogStationList"
                  :key="item.station_id"
                  :label="item.station_name"
                  :value="item.station_id">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="template-name">
            <span style="margin-top:10px;">模板名称：</span>
            <el-input v-model="templateName" :disabled="disabledWJ==true" clearable placeholder="请输入内容" style="margin-left:4px;width:54%;"></el-input>
          </div>
        </div>
        <div v-if="supplierNumber==1">
          <div class="dialog-center">
            <div class="dialog-center-title">费率/服务费设置（单位：元）</div>
            <div class="bottom-line"></div>
            <div class="dialog-center-input">
              <div class="input-box">
                <span class="input-box-title">费率1</span>
                <el-input v-model="rate1" :disabled="disabledWJ==true" clearable placeholder="费率1电费，单位元"></el-input>
              </div>
              <div class="input-box">
                <span class="input-box-title">费率2</span>
                <el-input v-model="rate2" :disabled="disabledWJ==true" clearable placeholder="费率2电费，单位元"></el-input>
              </div>
              <div class="input-box">
                <span class="input-box-title">费率3</span>
                <el-input v-model="rate3" :disabled="disabledWJ==true" clearable placeholder="费率3电费，单位元"></el-input>
              </div>
              <div class="input-box">
                <span class="input-box-title">费率4</span>
                <el-input v-model="rate4" :disabled="disabledWJ==true" clearable placeholder="费率4电费，单位元"></el-input>
              </div>
              <div class="input-box">
                <span class="input-box-title">服务费</span>
                <el-input v-model="servFee" :disabled="disabledWJ==true" clearable placeholder="服务费"></el-input>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div class="dialog-bottom">
            <div class="dialog-bottom-title">费率时段分配：<span>（时段必须覆盖24小时，时段1从00点开始，如果只设置1个时段，请选择00~24点作为开始和结束时间）</span></div>
            <div class="bottom-line"></div>
            <div class="dialog-bottom-select" v-for="(item,index) in timeIntervalList" :key="index">
              <span class="time1">时段{{index+1}}</span>
              <el-time-select
                v-model="item.timeslot_s"
                 :disabled="disabledWJ==true"
                :picker-options="{
                  start: '00:00',
                  step: '01:00',
                  end: '24:00'
                }"
                placeholder="选择开始时间点">
              </el-time-select>
              <el-time-select
                v-model="item.timeslot_e"
                 :disabled="disabledWJ==true"
                :picker-options="{
                  start: '00:00',
                  step: '01:00',
                  end: '24:00'
                }"
                placeholder="选择结束时间点">
              </el-time-select>
              <el-select v-model="item.timeslot_rate" :disabled="disabledWJ==true" clearable placeholder="请选择">
                <el-option
                  v-for="item in rateList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <div class="line2"></div>
            </div>
            <div style="clear:both;"></div>
            <div class="add-delete" v-if="disabledWJ==false">
              <span class="add" @click="addTimeInterval()">+</span>
              <span class="delete" @click="deleteTimeInterval()">-</span>
            </div>
            <div class="cencel-confirm" v-if="disabledWJ==false">
              <el-button class="cencel" @click="templateConcel()">取消</el-button>
              <el-button class="confirm" @click="templateConfirm()">确认</el-button>
            </div>
          </div>
        </div>
        <div v-else-if="supplierNumber==2">
          <div class="dialog-bottom dialog-bottom-weiji">
            <div class="dialog-bottom-title">费率时段分配：<span>（时段必须覆盖24小时，时段1从00点开始，如果只设置1个时段，请选择00~24点作为开始和结束时间）</span></div>
            <div class="bottom-line"></div>
            <div class="dialog-bottom-select" v-for="(item,index) in rateIntervalList" :key="index">
              <span class="time1">时段{{index+1}}</span>
              <el-time-select
                v-model="item.StartTime"
                 :disabled="disabledWJ==true"
                :picker-options="{
                  start: '00:00',
                  step: '00:30',
                  end: '24:00'
                }"
                placeholder="选择开始时间点">
              </el-time-select>
              <el-time-select
                v-model="item.EndTime"
                 :disabled="disabledWJ==true"
                :picker-options="{
                  start: '00:00',
                  step: '00:30',
                  end: '24:00'
                }"
                placeholder="选择结束时间点">
              </el-time-select>
              <el-input v-model="item.Price" :disabled="disabledWJ==true" clearable placeholder="请输入电费"></el-input>
              <el-input v-model="item.ServiePrice" :disabled="disabledWJ==true" clearable placeholder="请输入服务费"></el-input>
              <div class="line2"></div>
            </div>
            <div style="clear:both;"></div>
            <div class="add-delete" v-if="disabledWJ==false">
              <span class="add" @click="plusClick()">+</span>
              <span class="delete" @click="reduceClick()">-</span>
            </div>
            <div class="cencel-confirm" v-if="disabledWJ==false">
              <el-button class="cencel" @click="weijiConcel()">取消</el-button>
              <el-button class="confirm" @click="weijiConfirm()">确认</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from 'qs'
import { parseDateFilter } from "@/filters";
export default {
  data() {
    return {
      defaultValFilter:"--",
      stationList:[],
      newTemplateDialog:false,
      templateTitle:"新建模板",
      provincesList:[],
      provincesName:"",
      cityList:[],
      cityName:"",
      stationList:[],
      stationName:"",
      stationId:"",
      templateList:[],
      // 页面需要展现的数据
      yemiandata:[],
      // 页面展现条数
      datanum:10,
      // 开始页数
      startnum:0,
      // 结束页数
      endnum:1,
      // 一共多少页
      totalNum:0,
      timeIntervalList:[
        {
          timeslot_rate:"",
          timeslot_s:"",
          timeslot_e:"",
        }
      ],
      supplierList:[
        {
          value:"1",
          label:"统一费率",
        },
        {
          value:"2",
          label:"分时段费率",
        },
      ],//供应商
      supplierName:"统一费率",
      dialogCityList:[],
      dialogProvincesList:[],
      dialogProvincesName:"",
      dialogCityName:"",
      dialogStationName:"",
      dialogStationId:"",
      dialogStationList:[],
      templateName:"",
      rate1:"",
      rate2:"",
      rate3:"",
      rate4:"",
      servFee:"",
      rateList:[
        {
          value:"1",
          label:"费率1",
        },
        {
          value:"2",
          label:"费率2",
        },
        {
          value:"3",
          label:"费率3",
        },
        {
          value:"4",
          label:"费率4",
        }
      ],
      rateNumber:"",
      addPrivilege:1,//新建
      deletePrivilege:1,//删除
      supplierNumber:1,
      rateIntervalList:[
        {
          StartTime:"00:00",
          EndTime:"24:00",
          Price:"",
          ServiePrice:"",
        }
      ],
      disabledWJ:false,
    };
  },
  mounted() {
    this.$nextTick(function() {

      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        if(role[i].view_name == "充电管理"){
          for(let j in role[i].chlid){
            if(role[i].chlid[j].view_name == "计费模板"){
              for(let m in role[i].chlid[j].method){
                if(role[i].chlid[j].method[m].method_name == "新建"){
                  this.addPrivilege = 0;
                } else if(role[i].chlid[j].method[m].method_name == "删除"){
                  this.deletePrivilege = 0;
                }
              }
            }
          }
        }
      }
        
      this.getProvinces();
      this.getDataList();
    });
  },
  beforeRouteEnter(to, from, next) {
    window.document.querySelector("body").setAttribute("style", "background-color:#f8f8f8");
    window.document.querySelector("body").setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#efefef";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      this.yemiandata=this.templateList.slice(this.startnum*this.datanum,this.endnum*this.datanum);
    },
    getProvinces(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.provincesList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    provincesChange(province){
      this.cityName = "";
      this.stationName = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.cityList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    cityChange(city){
      this.stationName = "";
      this.stationId = "";
      this.getStation(city);
    },
    getStation(city){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.stationList = su.data.list;
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    stationChange(id){
      this.stationId = id;
    },
    getDataList(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        station_id:this.stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/ElectricPrice/get_rate_templates",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            // debugger
            this.templateList = su.data.data;
            if(this.templateList.length == 0){
              this.yemiandata = [];
            }
            this.totalNum = this.templateList.length;
            if(this.totalNum > 10){
              this.yemiandata=this.templateList.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=su.data.data;
            }
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
          } else if (su.data.code == 304)  {
            if(su.data.data.length == 0){
              this.yemiandata = [];
            }
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            // this.$message.error("当前场站没有数据");
          } else if (su.data.code == 900)  {
            this.$message.error(su.data.message);
          } else {
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList();
    },
    newTemplateClick(){
      this.templateTitle = "新建模板";
      this.newTemplateDialog = true;
      this.disabledWJ = false;
      this.dialogGetProvinces();
    },
    deleteTemplate(row){
      // debugger

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:row.id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/ElectricPrice/delete_rate_template",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList();
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
    dialogGetProvinces(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.dialogProvincesList = su.data.list;
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {
          this.$message.error('获取省份接口请求失败');
        });
    },
    dialogProvincesChange(province){
      this.dialogCityName = "";
      this.dialogStationName = "";
      this.dialogStationId = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province:province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if(su.data.code == 1){
            this.dialogCityList = su.data.list;
          } else if(su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if(su.data.code == 300) {
            localStorage.clear(); 
            this.$router.push('/login');
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {
        });
    },
    dialogCityChange(city){
      this.dialogStationName = "";
      this.dialogStationId = "";
      this.dialogGetStation(city);
    },
    dialogGetStation(city){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city:city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.dialogStationList = su.data.list;
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    dialogStationChange(id){
      this.dialogStationId = id;
    },
    addTimeInterval(){
      let num = this.timeIntervalList.length;
      // console.log(this.timeIntervalList);
      if(num > 11){
        this.$message.warning("最多增加12个");
      } else {
        this.timeIntervalList.push({
          timeslot_rate:"",
          timeslot_s:"",
          timeslot_e:"",
        });
      }
      
    },
    deleteTimeInterval(){
      // debugger
      let num = this.timeIntervalList.length;
      this.timeIntervalList.splice(num-1,1);
      
      // console.log(this.timeIntervalList);
    },
    templateConcel(){
      this.newTemplateDialog = false;
      this.supplierNumber = 1;
      this.supplierName = "统一费率";
      this.dialogProvincesName = "";
      this.dialogCityName = "";
      this.dialogStationName = "";
      this.templateName = "";
      this.dialogStationId = "";
      this.dialogStationList = [];
      this.rate1 = "";
      this.rate2 = "";
      this.rate3 = "";
      this.rate4 = "";
      this.servFee = "";
      this.timeIntervalList = [
        {
          timeslot_rate:"",
          timeslot_s:"",
          timeslot_e:"",
        }
      ];

      this.rateIntervalList = [
        {
          Price:"",
          ServiePrice:"",
          StartTime:"00:00",
          EndTime:"24:00",
        }
      ];
      this.disabledWJ = false;
    },
    templateConfirm(){
      let timeslot1_s="";
      let timeslot1_e="";
      let timeslot1_rate="";
      let timeslot2_s="";
      let timeslot2_e="";
      let timeslot2_rate="";
      let timeslot3_s="";
      let timeslot3_e="";
      let timeslot3_rate="";
      let timeslot4_s="";
      let timeslot4_e="";
      let timeslot4_rate="";
      let timeslot5_s="";
      let timeslot5_e="";
      let timeslot5_rate="";
      let timeslot6_s="";
      let timeslot6_e="";
      let timeslot6_rate="";
      let timeslot7_s="";
      let timeslot7_e="";
      let timeslot7_rate="";
      let timeslot8_s="";
      let timeslot8_e="";
      let timeslot8_rate="";
      let timeslot9_s="";
      let timeslot9_e="";
      let timeslot9_rate="";
      let timeslot10_s="";
      let timeslot10_e="";
      let timeslot10_rate="";
      let timeslot11_s="";
      let timeslot11_e="";
      let timeslot11_rate="";
      let timeslot12_s="";
      let timeslot12_e="";
      let timeslot12_rate="";

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        supplier:this.supplierName,
        station_id:this.dialogStationId,
        name:this.templateName,
        rate1:this.rate1,
        rate2:this.rate2,
        rate3:this.rate3,
        rate4:this.rate4,
        serv_fee:this.servFee,
        timeslot1_s:timeslot1_s,
        timeslot1_e:timeslot1_e,
        timeslot1_rate:timeslot1_rate,
      };
// debugger
      for(let i in this.timeIntervalList){
        this.timeIntervalList[i].timeslot_s = this.timeIntervalList[i].timeslot_s.substring(0,2);
        this.timeIntervalList[i].timeslot_e = this.timeIntervalList[i].timeslot_e.substring(0,2);
        // console.log(this.timeIntervalList[i].timeslot_s);
        if(this.timeIntervalList.length==1){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
        } else if(this.timeIntervalList.length==2){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
        } else if(this.timeIntervalList.length==3){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
        } else if(this.timeIntervalList.length==4){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
        } else if(this.timeIntervalList.length==5){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
        } else if(this.timeIntervalList.length==6){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
        } else if(this.timeIntervalList.length==7){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
          params.timeslot7_s=this.timeIntervalList[6].timeslot_s;
          params.timeslot7_e=this.timeIntervalList[6].timeslot_e;
          params.timeslot7_rate=this.timeIntervalList[6].timeslot_rate;
        } else if(this.timeIntervalList.length==8){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
          params.timeslot7_s=this.timeIntervalList[6].timeslot_s;
          params.timeslot7_e=this.timeIntervalList[6].timeslot_e;
          params.timeslot7_rate=this.timeIntervalList[6].timeslot_rate;
          params.timeslot8_s=this.timeIntervalList[7].timeslot_s;
          params.timeslot8_e=this.timeIntervalList[7].timeslot_e;
          params.timeslot8_rate=this.timeIntervalList[7].timeslot_rate;
        } else if(this.timeIntervalList.length==9){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
          params.timeslot7_s=this.timeIntervalList[6].timeslot_s;
          params.timeslot7_e=this.timeIntervalList[6].timeslot_e;
          params.timeslot7_rate=this.timeIntervalList[6].timeslot_rate;
          params.timeslot8_s=this.timeIntervalList[7].timeslot_s;
          params.timeslot8_e=this.timeIntervalList[7].timeslot_e;
          params.timeslot8_rate=this.timeIntervalList[7].timeslot_rate;
          params.timeslot9_s=this.timeIntervalList[8].timeslot_s;
          params.timeslot9_e=this.timeIntervalList[8].timeslot_e;
          params.timeslot9_rate=this.timeIntervalList[8].timeslot_rate;
        } else if(this.timeIntervalList.length==10){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
          params.timeslot7_s=this.timeIntervalList[6].timeslot_s;
          params.timeslot7_e=this.timeIntervalList[6].timeslot_e;
          params.timeslot7_rate=this.timeIntervalList[6].timeslot_rate;
          params.timeslot8_s=this.timeIntervalList[7].timeslot_s;
          params.timeslot8_e=this.timeIntervalList[7].timeslot_e;
          params.timeslot8_rate=this.timeIntervalList[7].timeslot_rate;
          params.timeslot9_s=this.timeIntervalList[8].timeslot_s;
          params.timeslot9_e=this.timeIntervalList[8].timeslot_e;
          params.timeslot9_rate=this.timeIntervalList[8].timeslot_rate;
          params.timeslot10_s=this.timeIntervalList[9].timeslot_s;
          params.timeslot10_e=this.timeIntervalList[9].timeslot_e;
          params.timeslot10_rate=this.timeIntervalList[9].timeslot_rate;
        } else if(this.timeIntervalList.length==11){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
          params.timeslot7_s=this.timeIntervalList[6].timeslot_s;
          params.timeslot7_e=this.timeIntervalList[6].timeslot_e;
          params.timeslot7_rate=this.timeIntervalList[6].timeslot_rate;
          params.timeslot8_s=this.timeIntervalList[7].timeslot_s;
          params.timeslot8_e=this.timeIntervalList[7].timeslot_e;
          params.timeslot8_rate=this.timeIntervalList[7].timeslot_rate;
          params.timeslot9_s=this.timeIntervalList[8].timeslot_s;
          params.timeslot9_e=this.timeIntervalList[8].timeslot_e;
          params.timeslot9_rate=this.timeIntervalList[8].timeslot_rate;
          params.timeslot10_s=this.timeIntervalList[9].timeslot_s;
          params.timeslot10_e=this.timeIntervalList[9].timeslot_e;
          params.timeslot10_rate=this.timeIntervalList[9].timeslot_rate;
          params.timeslot11_s=this.timeIntervalList[10].timeslot_s;
          params.timeslot11_e=this.timeIntervalList[10].timeslot_e;
          params.timeslot11_rate=this.timeIntervalList[10].timeslot_rate;
        } else if(this.timeIntervalList.length==12){
          params.timeslot1_s=this.timeIntervalList[0].timeslot_s;
          params.timeslot1_e=this.timeIntervalList[0].timeslot_e;
          params.timeslot1_rate=this.timeIntervalList[0].timeslot_rate;
          params.timeslot2_s=this.timeIntervalList[1].timeslot_s;
          params.timeslot2_e=this.timeIntervalList[1].timeslot_e;
          params.timeslot2_rate=this.timeIntervalList[1].timeslot_rate;
          params.timeslot3_s=this.timeIntervalList[2].timeslot_s;
          params.timeslot3_e=this.timeIntervalList[2].timeslot_e;
          params.timeslot3_rate=this.timeIntervalList[2].timeslot_rate;
          params.timeslot4_s=this.timeIntervalList[3].timeslot_s;
          params.timeslot4_e=this.timeIntervalList[3].timeslot_e;
          params.timeslot4_rate=this.timeIntervalList[3].timeslot_rate;
          params.timeslot5_s=this.timeIntervalList[4].timeslot_s;
          params.timeslot5_e=this.timeIntervalList[4].timeslot_e;
          params.timeslot5_rate=this.timeIntervalList[4].timeslot_rate;
          params.timeslot6_s=this.timeIntervalList[5].timeslot_s;
          params.timeslot6_e=this.timeIntervalList[5].timeslot_e;
          params.timeslot6_rate=this.timeIntervalList[5].timeslot_rate;
          params.timeslot7_s=this.timeIntervalList[6].timeslot_s;
          params.timeslot7_e=this.timeIntervalList[6].timeslot_e;
          params.timeslot7_rate=this.timeIntervalList[6].timeslot_rate;
          params.timeslot8_s=this.timeIntervalList[7].timeslot_s;
          params.timeslot8_e=this.timeIntervalList[7].timeslot_e;
          params.timeslot8_rate=this.timeIntervalList[7].timeslot_rate;
          params.timeslot9_s=this.timeIntervalList[8].timeslot_s;
          params.timeslot9_e=this.timeIntervalList[8].timeslot_e;
          params.timeslot9_rate=this.timeIntervalList[8].timeslot_rate;
          params.timeslot10_s=this.timeIntervalList[9].timeslot_s;
          params.timeslot10_e=this.timeIntervalList[9].timeslot_e;
          params.timeslot10_rate=this.timeIntervalList[9].timeslot_rate;
          params.timeslot11_s=this.timeIntervalList[10].timeslot_s;
          params.timeslot11_e=this.timeIntervalList[10].timeslot_e;
          params.timeslot11_rate=this.timeIntervalList[10].timeslot_rate;
          params.timeslot12_s=this.timeIntervalList[11].timeslot_s;
          params.timeslot12_e=this.timeIntervalList[11].timeslot_e;
          params.timeslot12_rate=this.timeIntervalList[11].timeslot_rate;
        }
      }
      
      
      this.$api({
        method: "post",
        url: "/api.php/ElectricPrice/add_rate_template",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.newTemplateDialog = false;
            this.provincesName = "";
            this.cityName = "";
            this.stationName = "";
            this.stationId = "";
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.getDataList();
            this.supplierNumber = 1;
            this.supplierName = "统一费率";
            this.dialogProvincesName = "";
            this.dialogCityName = "";
            this.dialogStationName = "";
            this.templateName = "";
            this.dialogCityName = "";
            this.dialogStationName = '';
            this.dialogStationId = "";
            this.dialogStationList = [];
            this.rate1 = "";
            this.rate2 = "";
            this.rate3 = "";
            this.rate4 = "";
            this.servFee = "";
            this.timeIntervalList = [
              {
                timeslot_rate:"",
                timeslot_s:"",
                timeslot_e:"",
              }
            ];
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    supplierChange(value){
      if(value == '统一费率'){
        this.supplierNumber = 1;
      } else if(value == '分时段费率'){
        this.supplierNumber = 2;
      }
    },
    plusClick(){
      // debugger
      this.rateIntervalList.push({
        StartTime: this.rateIntervalList[this.rateIntervalList.length-1].EndTime=='24:00'?'00:00':this.rateIntervalList[this.rateIntervalList.length-1].EndTime,
        EndTime: "24:00",
        Price:"",
        ServiePrice:"",
      });
      // this.rateIntervalList.push({
      //   StartTime: '',
      //   EndTime: "",
      //   Price:"",
      //   ServiePrice:"",
      // });
    },
    reduceClick(){
      // debugger
      let that = this;
      if(that.rateIntervalList.length == 1){
        that.$message.warning('就剩一条了');
      } else {
        that.rateIntervalList.splice( that.rateIntervalList.length-1, 1 );
      }
   
      // that.$forceUpdate();
    },
    weijiConcel(){
      this.newTemplateDialog = false;
      this.supplierNumber = 1;
      this.supplierName = "统一费率";
      this.dialogStationId = "";
      this.dialogProvincesName = "";
      this.dialogCityName = "";
      this.dialogStationName = "";
      this.templateName = "";
      this.rateIntervalList = [
        {
          Price:"",
          ServiePrice:"",
          StartTime:"00:00",
          EndTime:"24:00",
        }
      ];
      this.disabledWJ = false;
    },
    weijiConfirm(){
      // console.log(this.dialogStationId);
      // return

      if (isEmpty(this.supplierName)) {
        this.$message.warning('请选择供应商！');
        return;
      } else if (isEmpty(this.dialogStationId)) {
        this.$message.warning('请选择场站！');
        return;
      } else if (isEmpty(this.templateName)) {
        this.$message.warning('请填写模板名称！');
        return;
      }
      
      //保留两位小数
      for(let i in this.rateIntervalList){

        if (isEmpty(this.rateIntervalList[i].Price)) {
          this.$message.warning('请填写电费！');
          return;
        } else if (isEmpty(this.rateIntervalList[i].ServiePrice)) {
          this.$message.warning('请填写服务费！');
          return;
        }
        
        this.rateIntervalList[i].Price = Number(this.rateIntervalList[i].Price).toFixed(2);
        this.rateIntervalList[i].ServiePrice = Number(this.rateIntervalList[i].ServiePrice).toFixed(2);
        if(this.rateIntervalList[i].Price > 999.99 || this.rateIntervalList[i].ServiePrice > 999.99){
          this.$message.warning('电费和服务费不能大于999.99');
        }
        // console.log(parseFloat(this.rateIntervalList[i].Price).toFixed(2));
      }
      // this.rateIntervalList = this.rateIntervalList.toString();
      // console.log(this.rateIntervalList.toString());
      // return
      // let params = {
      //   uid: localStorage.getItem("uid"),
      //   token: localStorage.getItem("token"),
      //   action:'temple_save',
      //   // station_id:this.dialogStationId,
      //   station_id:'1234567890',
      //   name:this.templateName,
      //   supplier:this.supplierName,
      //   parking_rates:this.rateIntervalList
      // };
      // console.log(Qs.stringify(this.rateIntervalList));
      this.$api({
        method: "post",
        url: "/api.php/temple/temple_save",
        // data: params,
        // transformRequest: [
        //   data => {
        //     let ret = "";
        //     for (let it in data) {
        //       ret +=
        //         encodeURIComponent(it) +
        //         "=" +
        //         encodeURIComponent(data[it]) +
        //         "&";
        //     }
        //     return ret;
        //   }
        // ]
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' 
        },
        transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
          data = Qs.stringify(data)
          return data
        }],
        params: {}, 
        data: {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action:'temple_save',
          station_id:this.dialogStationId,
          name:this.templateName,
          supplier:this.supplierName,
          parking_rates:this.rateIntervalList
        },
        // headers: {'Content-Type': 'application/json'},
      })
        .then(su => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.newTemplateDialog = false;
            this.getDataList();
            this.supplierNumber = 1;
            this.supplierName = "统一费率";
            this.dialogStationId = "";
            this.dialogProvincesName = "";
            this.dialogCityName = "";
            this.dialogStationName = "";
            this.templateName = "";
            this.rateIntervalList = [
              {
                Price:"",
                ServiePrice:"",
                StartTime:"00:00",
                EndTime:"24:00",
              }
            ];
            this.disabledWJ = false;
          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {});
    },
    detailsTemplate(id){
      
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        id:id
      };
      this.$api({
        method: "post",
        url: "/api.php/temple/temple_detail",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.templateTitle = "模板详情";
            this.newTemplateDialog = true;
            // this.supplierNumber = 2;
            if(su.data.data.supplier=='分时段费率'){
              this.supplierNumber = 2;
              this.rateIntervalList = su.data.data.parking_rates;
            } else if(su.data.data.supplier=='统一费率') {
              this.supplierNumber = 1;
              // this.supplierName = '长园';
              this.timeIntervalList = su.data.data.data;
              for(let i in this.timeIntervalList){
                this.timeIntervalList[i].timeslot_s = this.timeIntervalList[i].StartTime + ':00';
                this.timeIntervalList[i].timeslot_e = this.timeIntervalList[i].EndTime + ':00';
                this.timeIntervalList[i].timeslot_rate = this.timeIntervalList[i].PriceId;
              }
            }
            this.supplierName = su.data.data.supplier;
            // console.log(this.timeIntervalList);
            this.disabledWJ = true;
            // this.dialogGetProvinces();
            this.dialogCityChange(su.data.data.city);
            // this.dialogStationChange(su.data.data.city);

            this.dialogStationId = su.data.data.station_id;
            this.dialogProvincesName = su.data.data.province;
            this.dialogCityName = su.data.data.city;
            this.dialogStationName = su.data.data.station_id;
            this.templateName = su.data.data.name;
            
            // 长园
            this.rate1 = Number(su.data.data.rate1).toFixed(2);
            this.rate2 = Number(su.data.data.rate2).toFixed(2);
            this.rate3 = Number(su.data.data.rate3).toFixed(2);
            this.rate4 = Number(su.data.data.rate4).toFixed(2);
            this.servFee = Number(su.data.data.serv_fee).toFixed(2);

          } else if (su.data.code == 300)  {
            localStorage.clear(); 
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900)  {
          } else  {
            this.$message.error(su.data.message);
          }
        })
        .catch(err => {
          this.$message.error('获取详情接口请求失败');
        });
    }
  },
};
</script>

<style scoped lang="scss">
.charg-template {
  .charg-template-top {
    width: 98%;
    height: 60px;
    margin-left: 1%;
    margin-top: 16px;
    background-color: #ffffff;
    text-align: left;
    span {
      line-height: 60px;
      font-size: 16px;
      color: #0076bc;
      margin-left: 20px;
      font-weight: 700;
    }
  }
  .charg-template-bottom {
    width: 98%;
    margin-top: 12px;
    background-color: #ffffff;
    margin-left: 1%;
    .template-bottom-top {
      width: 98%;
      padding-top: 20px;
      display: flex;
      margin-left: 1%;
      .el-select {
        margin-right: 10px;
      }
      .search {
        background-color: #0071bd;
        color: #fefffd;
        border: none;
      }
      .search:active {
        background-color: #409EFF;
      }
      .new-template {
        background-color: #ec5400;
        color: #fefffd;
        border: none;
      }
      .new-template.active {
        background-color: #a5a5a5;
      }
    }
    .template-bottom-table {
      width: 98%;
      margin-top: 20px;
      margin-left: 1%;
      .list-delete {
        width: 52px;
        height: 26px;
        padding: 0 !important;
        background-color: #02B271;
        color: #ffffff;
        border:none;
        font-size: 12px;
      }
      .list-details {
        width: 52px;
        height: 26px;
        padding: 0 !important;
        background-color: #0071bd;
        color: #ffffff;
        border:none;
        font-size: 12px;
      }
      .list-delete.active {
        background-color: #a5a5a5;
      }
      .el-table td {
        padding:4px 0;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .new-template-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top:16px;
      color: #0171BD;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #EAEAEA;
    }
    .new-template-content {
      .dialog-top {
        width: 100%;
        margin-top: 20px;
        .one {
          width: 100%;
          display: flex;
          text-align: left;
          margin-left: 14px;
          .supplier {
            width: 45%;
            span {
            }
            .el-select {
              // width: 75%;
            }
          }
          .station {
            width: 65%;
            span {
            }
            .el-select {
              width: 28%;
            }
          }
        }
        .template-name {
          width: 45%;
          display: flex;
          margin-top: 10px;
          margin-left: 14px;
          span {
          }
          .el-input {
            width: 55%;
          }
        }
      }
      .dialog-center {
        margin-top: 30px;
        .dialog-center-title {
          font-size: 16px;
          color: #555555;
          text-align: left;
        }
        .bottom-line {
          width: 100%;
          height: 1px;
          background-color: #EEEEEE;
          margin-top: 22px;
        }
        .dialog-center-input {
          width: 100%;
          .input-box {
            width: 30%;
            float: left;
            margin-top: 20px;
            .input-box-title {
              text-align: left;
              line-height: 40px;
            }
            .el-input {
              width: 70%;
              float: right;
            }
          }
        }
      } 
      .dialog-bottom {
        margin-top: 30px;
        .dialog-bottom-title {
          font-size: 16px;
          color: #555555;
          text-align: left;
          span {
            font-size: 12px;
            color: #EC0100;
          }
        }
        .bottom-line {
          width: 100%;
          height: 1px;
          background-color: #EEEEEE;
          margin-top: 22px;
        }
        .dialog-bottom-select {
          width: 100%;
          margin-top: 20px;
          float: left;
          .time1 {
            display: inline-block;
            width: 7%;
          }
          .el-date-editor {
            width: 29%;
          }
          .line2 {
            width: 100%;
            height: 1px;
            background-color: #EEEEEE;
            margin-top: 16px;
          }
        }
        .add-delete {
          margin-top: 20px;
          display: flex;
          span {
            display: inline-block;
            width: 50px;
            height: 40px;
            background-color: #E7E7E7;
            color: #777777;
            line-height: 40px;
            text-align: center;
            font-size: 26px;
            margin-right: 10px;
            border-radius: 6px;
            cursor: pointer;
          }
        }
        .cencel-confirm {
          margin-top: 20px;
          .el-button {
            width: 25%;
            color:#ffffff;
            border:none;
            height: 50px;
          }
          .cencel {
            background-color: #0071BD;
          }
          .confirm {
            background-color: #02B36F;
          }
        }
      } 
      .dialog-bottom-weiji {
        .dialog-bottom-select {
          .el-date-editor,.el-input {
            width: 21%;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
// .charg-template {
//   .el-table td {
//     padding: 5px 0;
//   }
// }
.charg-template {
  .el-table td, .el-table th {
    padding: 6px 0 !important;
  }
}
.new-template-dialog .new-template-content .el-input.is-disabled .el-input__inner {
  background-color: #ffffff;
  color: #606266;
}
</style>


// WEBPACK FOOTER //
// src/components/chargeManagement/chargingTemplate.vue